<template>
  <v-dialog
    v-model="opened"
    content-class="edit-dialog"
    max-width="350"
    persistent
  >
    <h3 class="edit-dialog__title">{{ title }}</h3>

    <v-btn class="close-btn" icon @click="opened = false">
      <v-icon size="27" color="#464646"> mdi-close-circle-outline </v-icon>
    </v-btn>

    <v-form ref="edit-form" @submit.prevent="onSubmit">
      <v-text-field
        v-model="input"
        outlined
        filled
        dense
        :rules="rules"
        :disabled="loading"
      />
      <v-btn
        type="submit"
        color="warning"
        elevation="0"
        block
        :loading="loading"
      >
        {{ $t('common.btns.save') }}
      </v-btn>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  model: {
    event: 'change',
    prop: 'value',
  },
  props: {
    option: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: [Number, String],
      required: true,
    },
    currentValue: {
      type: [String, Number, null],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    input: '',
  }),
  watch: {
    opened(val) {
      if (!val) {
        this.$refs['edit-form'].reset();
      }

      if (this.currentValue) {
        const value = this.currentValue;
        this.input = this.option === 'amount' ? Number(value) : value;
      }
    },
  },
  computed: {
    opened: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
    title() {
      switch (this.option) {
        case 'violation_number':
          return this.$t('fines.table.prescriptionNumber');
        case 'amount':
          return this.$t('common.fields.sum');

        default:
          return this.$t('common.btns.edit');
      }
    },
    rules() {
      const list = [];

      if (this.option === 'violation_number') {
        list.push(this.isRequired);
      }

      if (this.option === 'amount') {
        list.push(this.onlyNumbers);
      }

      return list;
    },
  },
  methods: {
    isRequired(v) {
      return !!v || this.$t('common.fields.validation.field.required');
    },
    onlyNumbers(v) {
      if (!v) return true;
      return (
        /^[0-9]{1,12}$/.test(v) || this.$t('common.fields.validation.numbers')
      );
    },
    async onSubmit() {
      const isValid = this.$refs['edit-form'].validate();

      if (!isValid) return;

      this.loading = true;

      const params = { [this.option]: this.input };
      const result = await this.$store.dispatch('fines/updateItem', {
        id: this.itemId,
        params,
      });

      this.$emit('saved', result);
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.edit-dialog {
  padding: 10px;
  background-color: #fff;

  &__title {
    text-align: center;
    font-size: 18px;
    color: #464646;
    margin-bottom: 20px;
  }
}
</style>
